import type { SafeVideo } from '../types';

export const videos: SafeVideo[] = [
  {
    id: 'omar-hana',
    title: 'Omar & Hana: Begin With Bismillah',
    category: 'Islamic Cartoons',
    provider: 'Omar & Hana',
    url: 'https://www.youtube.com/watch?v=25lhpOtTmyg',
  },
  {
    id: 'minimuslims',
    title: 'MiniMuslims: Repeat Surat Al-Fatihah',
    category: 'Quran for Kids',
    provider: 'MiniMuslims',
    url: 'https://www.youtube.com/watch?v=3KZ4yp3RR3k',
  },
  {
    id: 'one4kids',
    title: 'Zaky: Story of Prophet Adam',
    category: 'Stories of the Prophets',
    provider: 'One4Kids / Zaky',
    url: 'https://www.youtube.com/watch?v=T8GrguVA1zM',
  },
  {
    id: 'arabic-lessons',
    title: 'Learn the Arabic Alphabet',
    category: 'Arabic Lessons',
    provider: 'Parent-approved Arabic lesson',
    url: 'https://www.youtube.com/watch?v=Ua9HdBkF9Pg',
  },
  {
    id: 'qaida',
    title: 'Qaida Noorania: Lesson One',
    category: 'Qaida Noorania',
    provider: 'Parent-approved Qaida lesson',
    url: 'https://www.youtube.com/watch?v=wO2DRVC-g9w',
  },
  {
    id: 'ramadan',
    title: 'MiniMuslims: Ramadan Around The World',
    category: 'Ramadan videos',
    provider: 'MiniMuslims',
    url: 'https://www.youtube.com/watch?v=4VpiuY_C5Ok',
  },
];
